import type {Context} from '../types';

// Fix up legacy Stripe elements
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {type, data = {}} = jsonNode;
  const legacyStripeElement = type === 'CommerceCheckoutStripeElement';

  return {
    needed: legacyStripeElement,
    logData: {
      msg: 'Legacy Stripe element',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      if (data.elementType === 'cardCvc') {
        jsonNode.type = 'CommerceCheckoutCardSecurityCode';
      } else if (data.elementType === 'cardExpiry') {
        jsonNode.type = 'CommerceCheckoutCardExpirationDate';
      } else {
        // data.elementType === 'cardNumber'
        jsonNode.type = 'CommerceCheckoutCardNumber';
      }
      // eslint-disable-next-line webflow/no-delete
      delete data.elementType;
    },
  };
};
